module.exports = __webpack_public_path__ + "static/media/Mastercard.15044f41.svg";